import { useEffect, useRef, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OrderHeader from '../components/order/OrderHeader';
import { createCheckout } from '../api';
import './Order.css';

// The link in a payment request email (custom orders). It doesn't go to
// Mollie directly: a Mollie payment expires, so this page asks for one when
// it's opened - the same one if it can still be paid - and goes there.
function Pay() {
  const { t } = useTranslation();
  const { publicId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [error, setError] = useState(null);
  // Ask for the payment once. React runs effects twice in development, and
  // two requests used to mean two Mollie payments - the server now hands
  // the second the same payment, but there's no reason to ask twice.
  const asked = useRef(false);

  useEffect(() => {
    if (asked.current) return;
    asked.current = true;
    createCheckout(publicId, token)
      .then(({ checkout_url }) => {
        window.location.href = checkout_url;
      })
      .catch((err) => setError(err.message));
  }, [publicId, token]);

  const statusPath = `/orders/${publicId}?token=${encodeURIComponent(token)}`;

  return (
    <div className="atelier of">
      <OrderHeader home />
      <main className="ty">
        <div className={`ty-mark ty-mark--${error ? 'failed' : 'waiting'}`} aria-hidden="true">
          {error ? <span>!</span> : <span className="ty-dots" />}
        </div>
        <h1 className="ty-title">{error ? t('pay.failed') : t('pay.redirecting')}</h1>
        {error && (
          <>
            <p className="of-error">{error}</p>
            <Link to={statusPath} className="of-btn ty-restart">
              {t('pay.toOrder')}
              <span aria-hidden="true">&rarr;</span>
            </Link>
          </>
        )}
      </main>
    </div>
  );
}

export default Pay;
